<template>
  <form class="booking-confirm" @submit.prevent="confirm">
    <div class="modal-content-generic">
      <div class="content lh-loose">
        <div class="booking-schedule">
            <div class="production-period font-mdish" v-if="data.requested_from != data.requested_to"><strong class="wt-sb">Production Period:</strong> {{ data.date_range_formatted }}</div>
            <div class="production-period font-mdish" v-if="data.requested_from == data.requested_to"><strong class="wt-sb">Production Date:</strong> {{ data.date_range_formatted }}</div>
            <table>
                <tr>
                    <th>Day</th>
                    <th>
                      {{ data.type === 'recce' ? 'Arrival Time' : 'Call Times'}}
                    </th>
                </tr>
                <tr v-for="day in data.days_and_times_formatted">
                    <td>{{ day.day }}</td>
                    <td>{{ day.time }}</td>
                </tr>
            </table>
        </div>
      </div>
    </div>
    <div class="modal-actions">
      <div class="action">
        <button type="button" class="button tertiary" @click="$emit('cancel')">
          <svg-icon id="chevronLeft"></svg-icon>
          <span>Cancel</span>
        </button>
      </div>
      <div class="action">
        <loader-button
            type="submit"
            :loading="loading"
            :label="`Confirm ${data.type}`"
            class="button coral"
        ></loader-button>
      </div>
    </div>
  </form>
</template>

<script>
import BaseModal from '../../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      reason: null,
      errors: {},
      loading: false
    }
  },
  methods: {
    confirm () {
      this.errors = {}
      this.loading = true
      axios.put(`/api/account/bookings/${this.data.id}/confirm`)
          .then(() => {
            this.$toasted.show(`Thank you for accepting you ${this.data.booking_type_label}.`, { type: 'success' })
            this.reason = null
            this.$emit('confirm')
            this.$eventBus.$emit('update_listing_booking-item')
          })
          .catch(error => {
            this.$toasted.show(
                `Your ${this.data.booking_type_label} could not be confirmed, please refresh the page and try again.`, {
                  type: 'error'
                })
          })
          .then(() => {
            this.loading = false
          })
    }
  }
}
</script>
